import React from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  color: #828282;
  font-size: 10px;
  line-height: 130%;
  padding: ${(props: { isWide: boolean }) =>
    props.isWide ? '15px 150px 24px' : '12px 8px 15px 8px'};
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `margin-left: auto;
      margin-right: auto;
      text-align: center;
      width: 61%;`
      : ``}
`;

interface Props {
  isWide: boolean;
}

export const InquiryWarning = (props: Props) => {
  const { isWide } = props;
  const WARNING_MESSAGE =
    'お問い合わせ対応や品質向上のため、メッセージ送信時の内容とお名前をお問い合わせ先および楽天グループ(株)が取得・閲覧します。同意の上でご利用ください。';

  return <StyledSection isWide={isWide}>{WARNING_MESSAGE}</StyledSection>;
};
